import { RouteRecordRaw } from 'vue-router'
import { metaDataAuthGuard } from '@shared/guards/auth'
import { AuthScope, PermissionLevel } from '@shared/stores/auth'
import type { ExtractRouteNames } from '@shared/types/RouteNames'

// components
const SubscriptionAdmin = () => import(/* webpackChunkName: "SubscriptionAdmin" */ '@subscriptions/views/SubscriptionAdmin.vue')
const SubscriptionAdminManageSubscription = () => import(/* webpackChunkName: "SubscriptionAdminManageSubscription" */ '@subscriptions/views/SubscriptionAdminManageSubscription.vue')
const SubscriptionAdminManageOrgs = () => import(/* webpackChunkName: "SubscriptionAdminManageOrgs" */ '@subscriptions/views/SubscriptionAdminManageOrgs.vue')
const SubscriptionAdminManageUsers = () => import(/* webpackChunkName: "SubscriptionAdminManageUsers" */ '@subscriptions/views/SubscriptionAdminManageUsers.vue')

// Subscription Management
export const routes = {
    path: '/subscription-management',
    name: 'SubscriptionManagement',
    component: SubscriptionAdmin,
    beforeEnter: metaDataAuthGuard,
    redirect: { name: 'SubscriptionManagementManageSubscription' },
    meta: {
        requiredScopes: [{ level: PermissionLevel.All, scope: AuthScope.Instance }],
    },
    children: [
        // Identity management
        {
            path: 'manage-subscription',
            name: 'SubscriptionManagementManageSubscription',
            component: SubscriptionAdminManageSubscription,
            beforeEnter: metaDataAuthGuard,
            meta: {
                requiredScopes: [{ level: PermissionLevel.All, scope: AuthScope.Client }],
                fallbackRedirect: 'SubscriptionManagementManageInstances',
            },
        },
        {
            path: 'manage-users',
            name: 'SubscriptionManagementManageUsers',
            beforeEnter: metaDataAuthGuard,
            meta: {
                requiredScopes: [{ level: PermissionLevel.All, scope: AuthScope.Client }],
                fallbackRedirect: 'SubscriptionManagementManageInstances',
            },
            component: SubscriptionAdminManageUsers,
        },
        {
            path: 'manage-instances',
            name: 'SubscriptionManagementManageInstances',
            beforeEnter: metaDataAuthGuard,
            component: SubscriptionAdminManageOrgs,
        },
    ] as const satisfies RouteRecordRaw[],
} as const satisfies RouteRecordRaw

export type SubscriptionManagementRouteNames = ExtractRouteNames<typeof routes> | ExtractRouteNames<typeof routes.children[number]>

export default routes
